<div style="display: flex; justify-content: end">
  <div *ngIf="isDateRangeValid">
    <p-button
      label="Download All Document"
      (click)="getSelectedOrderPdf()"
      styleClass="p-button-sm-outline"
      icon="pi pi-download"
      iconPos="left"
    ></p-button>
  </div>
</div>

<app-data-table
  #dataTable
  [columnChooser]="true"
  [draggableColumns]="true"
  [columns]="columns"
  [data]="orders"
  [totalRecords]="totalRecords"
  [rows]="rowsPerPage"
  [paginator]="true"
  [lazy]="true"
  emptyMessage="No Records Found"
  [getRowClass]="rowClassFor"
  [analyticsTab]="'Individual'"
  (columnSort)="sort($event)"
  (pageChange)="onPageChange($event)"
  (rowsChange)="onRowsPerPageChange($event)"
  (rowClick)="viewOrder($event, viewOrderData)"
  (columnVisibilityChange)="onColumnVisibilityChange($event)"
>
  <ng-template appTableCell="status" let-row>
    <app-status-badge [status]="getDisplayStatus(row)"></app-status-badge>
  </ng-template>

  <ng-template appTableCell="action" let-row>
    <div class="action-buttons" appRowActionStop>
      <a
        *ngIf="row.status === 'Approval Pending'"
        class="viewmore"
        appIconAction
        (click)="viewOrder(row, viewOrderData)"
        ><i
          class="pi pi-folder-open"
          pTooltip="Review & Approve Order"
          tooltipPosition="top"
        ></i
      ></a>

      <a
        *ngIf="row.status !== 'Approval Pending'"
        class="viewmore"
        appIconAction
        (click)="viewOrder(row, viewOrderData)"
        ><i
          class="pi pi-eye"
          pTooltip="View Order"
          tooltipPosition="top"
        ></i
      ></a>

      <a
        *ngIf="row.status === 'Draft'"
        class="viewmore clickable"
        (click)="editDraftOrder(row)"
      >
        <i
          class="pi pi-pencil"
          pTooltip="Edit Draft"
          tooltipPosition="top"
        ></i>
      </a>

      <a
        *ngIf="
          (userRole === 'ACCOUNT-ADMIN' ||
            userRole === 'ORGANISATION-ADMIN') &&
          (row.status === 'Initiated' ||
            row.status === 'Wating For Stamp' ||
            row.status === 'Waiting For Stamp' ||
            (row.status === 'Wating For Payment' && row.is_cancel) ||
            (row.status === 'Waiting For Payment' && row.is_cancel))
        "
        class="viewmore clickable"
        (click)="cancelOrder(row, cancelOrderData)"
        ><i
          class="pi pi-times-circle"
          pTooltip="Cancel Order"
          tooltipPosition="top"
        ></i
      ></a>
    </div>
  </ng-template>
</app-data-table>

<ng-template #cancelOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Cancel Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="form_outline_sty row">
      <div class="col-6 form_inputFields">
        <span class="form_field">
          Reason For Cancellation <span class="color_red">*</span></span
        >
        <textarea
          style="height: 3rem"
          class="form-control edit_input"
          placeholder="Enter reason"
          [(ngModel)]="CancelledReason"
          pInputTextarea
        ></textarea>
      </div>
      <div class="col-6 form_inputFields">
        <span class="form_field"> Support Document For Cancellation</span>
        <div class="col-lg-4 col-sm-4 col-md-4 mt-2">
          <input
            [hidden]="true"
            type="file"
            id="upload_file"
            (change)="onFileChange($event)"
            #fileInput
            #upload_file
          />
          <button
            style="font-size: 0.7rem; margin-left: 1.4rem"
            type="button"
            (click)="fileInput.click()"
            class="btn btn-outline-secondary fileUploadStyle"
          >
            {{ fileName }}
          </button>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-lg-2 col-sm-2 col-md-2 mt-2">
          <p-button
            label="Proceed to Cancel "
            (click)="cancelSelectedOrder()"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
        <div
          class="col-lg-2 col-sm-2 col-md-2 mt-2"
          style="display: flex; justify-content: flex-end"
        >
          <p-button
            label="Close"
            (click)="closeModel()"
            class="ms-2"
            styleClass="p-button-sm"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Edit Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="edit-modal-body">
      <form [formGroup]="commonFieldsOrderForm">
        <div class="flexRow">
          <div class="form_inputFields">
            <span class="form_field">
              Reference Number <span class="color_red">*</span></span
            >
            <input
              placeholder="Enter Reference Number"
              class="form-control"
              formControlName="referenceNumber"
              pInputText
              type="text"
              onkeypress="
                return (
                  (event.charCode >= 65 && event.charCode <= 90) ||
                  (event.charCode >= 97 && event.charCode <= 122) ||
                  (event.charCode >= 48 && event.charCode <= 57) ||
                  event.charCode == 32 ||
                  event.charCode === 45
                );
              "
            />
            <span
              class="p-error"
              style="font-size: 0.5rem"
              *ngIf="
                submitted &&
                editEstampForm.get('referenceNumber')?.hasError('required')
              "
              >*Enter reference number</span
            >
          </div>
        </div>

        <div class="flexRow">
          <div class="form_inputFields">
            <span class="form_field ms-2"
              >Select State <span class="color_red">*</span></span
            >
            <div style="display: block">
              <app-dropdown
                class="custom-dropdown"
                [options]="stateData"
                formControlName="state"
                (onChange)="onEditStateChange($event)"
                placeholder="Select State"
                [filter]="true"
                filterBy="state_name"
                optionLabel="state_name"
                optionValue="id"
              ></app-dropdown>
            </div>
          </div>

          <div class="form_inputFields">
            <span class="form_field ms-2"
              >Select Branch <span class="color_red">*</span></span
            >
            <div style="display: block">
              <app-dropdown
                class="custom-dropdown"
                [options]="branchData"
                formControlName="branch"
                placeholder="Select Branch"
                [filter]="true"
                filterBy="name"
                optionLabel="name"
                optionValue="id"
              ></app-dropdown>
            </div>
          </div>
        </div>
      </form>

      <form [formGroup]="editEstampForm" class="mt-2">
        <span class="title_five ms-2" *ngIf="selectedOrder.estamp.length > 0">
          Estamp Details
        </span>
        <div
          *ngFor="let estamp of estampForms.controls; let i = index"
          class="form_outline_sty mt-1"
        >
          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Second Party Name <span class="color_red">*</span></span
              >
              <input
                placeholder="Enter second party name"
                class="form-control"
                formControlName="secondPartyName"
                pInputText
                type="text"
                maxlength="50"
                onkeypress="
                  return (
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    event.charCode == 32
                  );
                "
              />
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('secondPartyName')?.hasError('required')
                "
                >*Enter Second Party Name</span
              >
            </div>
            <div class="form_inputFields">
              <span class="form_field ms-2">
                Execution Date <span class="color_red">*</span></span
              >
              <div style="display: block" class="">
                <p-datepicker
                  #calendar
                  class="custom-calendar"
                  formControlName="execution_date"
                  [minDate]="minDate"
                  placeholder="Select Date"
                  [showIcon]="true"
                  iconDisplay="input"
                  [readonlyInput]="false"
                  inputId="dateformat"
                  dateFormat="dd/mm/yy"
                >
                </p-datepicker>
              </div>
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('execution_date')?.hasError('required')
                "
                >*Enter Date</span
              >
            </div>
          </div>

          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Stamp Duty Value <span class="color_red">*</span></span
              >
              <input
                class="form-control"
                formControlName="stampDutyValue"
                placeholder="Enter stamp Duty Value"
                pInputText
                type="number"
                (keypress)="numberOnly($event)"
              />
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('stampDutyValue')?.hasError('required')
                "
                >*Enter value</span
              >
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="estamp.get('stampDutyValue')?.hasError('min')"
                >*Stamp Duty cannot be less than 10</span
              >
            </div>

            <div class="form_inputFields">
              <span class="form_field ms-2">
                Stamp Duty Paid By <span class="color_red">*</span></span
              >
              <div style="display: block" class="overlay">
                <app-dropdown
                  [options]="stampDutyPaidByOptions"
                  class="custom-dropdown"
                  placeholder="Select stamp duty paid by"
                  [autoDisplayFirst]="false"
                  optionLabel="name"
                  optionValue="code"
                  formControlName="stampDutyPaidBy"
                ></app-dropdown>
              </div>
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  estamp.get('stampDutyPaidBy')?.hasError('required')
                "
                >*Select Paid By</span
              >
            </div>
          </div>
        </div>
      </form>

      <form [formGroup]="editEsignForm">
        <span class="title_five ms-2" *ngIf="selectedOrder.esign.length > 0">
          Esign Details
        </span>
        <div
          *ngFor="let esign of esignForms.controls; let i = index"
          class="form_outline_sty mt-1"
        >
          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Name <span class="color_red">*</span></span
              >
              <input
                placeholder="Enter second party name"
                class="form-control"
                formControlName="name"
                pInputText
                type="text"
                maxlength="50"
                onkeypress="
                  return (
                    (event.charCode >= 65 && event.charCode <= 90) ||
                    (event.charCode >= 97 && event.charCode <= 122) ||
                    (event.charCode >= 48 && event.charCode <= 57) ||
                    event.charCode == 32
                  );
                "
              />
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="submitted && esign.get('name')?.hasError('required')"
                >*Enter Second Party Name</span
              >
            </div>
            <div class="form_inputFields">
              <span class="form_field ms-2">
                Email <span class="color_red">*</span></span
              >
              <input
                class="form-control edit_input"
                formControlName="email"
                placeholder="Enter Email"
                pInputText
                type="text"
              />
              <span
                class="p-error"
                *ngIf="submitted && esign.get('email')?.hasError('required')"
                >*Enter valid Email
              </span>
            </div>
          </div>

          <div class="flexRow">
            <div class="form_inputFields">
              <span class="form_field">
                Contact Number <span class="color_red">*</span></span
              >
              <input
                class="form-control edit_input"
                formControlName="contact_number"
                placeholder="Enter Number"
                pInputText
                type="text"
                (keypress)="numberOnly($event)"
              />
              <span
                class="p-error"
                *ngIf="
                  submitted && esign.get('contact_number')?.hasError('required')
                "
                >*Mobile Number is required</span
              >
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="update-edit-footer">
      <div class="btnRow me-3 mt-2">
        <div>
          <p-button
            label="Cancel"
            (click)="closeEditOrderPopup()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
        <div>
          <p-button
            label="Save"
            (click)="editSelectedOrder()"
            class="ms-2"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Order</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <app-view-order [viewOrderId]="viewOrderId"></app-view-order>
  </div>
</ng-template>